export default function validation(response, messages) {
  if (!response.data.error || !response.data.error.validationErrors) {
    return;
  }
  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message.indexOf('The field Email') !== -1) {
      messages.push({
        message: 'editionClient.validation.email',
      });
    }
    if (message.indexOf('CLIENT_TYPE_INCORRECT@GroupeEnseigne') !== -1) {
      messages.push({
        message: 'editionClient.validation.clientTypeGroupeEnseigne',
      });
    }
    if (message.indexOf('CLIENT_TYPE_INCORRECT@EnseigneGroupe') !== -1) {
      messages.push({
        message: 'editionClient.validation.clientTypeEnseigneGroupe',
      });
    }
    if (message.indexOf('CALCUL_HONORAIRE_FORFAIT_AMOUNT_NULL') !== -1) {
      messages.push({
        message: 'editionClient.validation.calculHonoraireForfaitAmountNull',
      });
    }
    if (message.indexOf('CALCUL_HONORAIRE_POURCENTAGE_PERCENT_NULL') !== -1) {
      messages.push({
        message: 'editionClient.validation.calculHonorairePercentNull',
      });
    }
    if (message.indexOf('CALCUL_HONORAIRE_POURCENTAGE_AMOUNT_NOT_NULL') !== -1) {
      messages.push({
        message: 'editionClient.validation.calculHonorairePercentAmountNotNull',
      });
    }
    if (message.indexOf('CALCUL_HONORAIRE_FORFAIT_PERCENT_NOT_NULL') !== -1) {
      messages.push({
        message: 'editionClient.validation.calculHonorairForfaitPercentNotNull',
      });
    }
    if (message.indexOf('ACCOUNTING_ACCOUNT_REQUIRED') !== -1) {
      messages.push({
        message: 'editionClient.validation.accountingAccountRequired',
      });
    }
    if (message.indexOf('ACCOUNTING_ACCOUNT_TO_LONG') !== -1) {
      messages.push({
        message: 'editionClient.validation.accountingAccountToLong',
      });
    }
    if (message.indexOf('ADRESSE_POSTALE_CANNOT_BE_EMPTY') === 0) {
      messages.push({
        message: 'editionClient.validation.AdressePostaleCannotBeEmpty',
      });
    }
  });
}
